export const ADD_LIST_RESERVATION = 'ADD_LIST_RESERVATION';
export const ADD_RESERVATION = 'ADD_RESERVATION';
export const UPDATE_RESERVATION = 'UPDATE_RESERVATION';
export const ADD_LIST_CLUB = 'ADD_LIST_CLUB';